import { useCallback, useEffect, useState } from "react";
import { useGetHDBPropertyByNricQuery } from "../redux/services/getHDBProperty";
import { Properties } from "../models/polymer/Properties.model";
import { useAppSelector } from "../redux/hook";
import { PolymerCrypto } from "../utils/encryptor";
import { Helpers } from "../utils/helper";
import { PolymerAxios } from "../utils/axios";
import { API_EligibilityDebugLog } from "../utils/api";

function useCheckHdbProperties(uinfin:string, stage: "A" | "B" | "C" | "D" | "E") {


  const singpassToken = useAppSelector(state => state.auth.AuthenticationSlice.singpassToken);
  const originalLoginUser = useAppSelector(state => state.auth.AuthenticationSlice.originalLoginUser);

  const { data: HdbPropertyData, isError, error, isFetching: isLoading } = useGetHDBPropertyByNricQuery({uinfin:uinfin, singpass_token: singpassToken ?? ""}, {skip: !uinfin || stage === "C"});
  const [ hasMultipleAddress, setMultipleAddress ] = useState<boolean | undefined>(undefined);
  const [ singleProperty, setSingleProperty ] = useState<Properties | undefined>(undefined);
  const [ noProperty, setNoProperty ] = useState<boolean | undefined>(undefined);
  const [ isIncluded, setIsIncluded ] = useState<boolean | undefined>(undefined);

  useEffect(()=>{
    if(HdbPropertyData && !isError){
      const formattedProperties = HdbPropertyData.filter(e=>{
        if(e.owners?.some((owner: any) => uinfin === PolymerCrypto.decryption(owner.uinfin))){
          return true;
        }
        else if(e.additional_roles?.some((additional_role:any) => uinfin === PolymerCrypto.decryption(additional_role.uinfin))){
          return true;
        }
        else{
          return false;
        }
      })
      setIsIncluded(formattedProperties.length > 0);
      setMultipleAddress(formattedProperties?.length > 1);
      setNoProperty(formattedProperties.length === 0);
      if(formattedProperties?.length === 1){
        setSingleProperty(formattedProperties[0]);
      }
    }
  },[HdbPropertyData, isError, uinfin])

  const sendErrorLogs = useCallback(() => {
    const payload = {
      application_uuid: originalLoginUser?.uinfin,
      message: JSON.stringify({
        uinfin: originalLoginUser?.uinfin,
        error_message: `Error invoking RDB API for uinfin ${uinfin} with login user ${originalLoginUser?.uinfin}`,
        generic_error_message: "Frontend Interface Data Error",
        api_url: '/residential/list',
        error: error ? JSON.stringify(error) : "cannot find error trace"
     })
    }
    PolymerAxios(originalLoginUser?.uinfin ?? "", singpassToken).post(API_EligibilityDebugLog, payload)
  }, [originalLoginUser?.uinfin, singpassToken, isError, error, uinfin])

  useEffect(() => {
    if(isError) {
      sendErrorLogs();
      if(JSON.parse(JSON.stringify(error))?.status == 401) {
        Helpers.clearSingpassAuthPersistData();
        Helpers.clearAuthPersistData();
        Helpers.clearPersistData();
        window.location.href = "/transfer";
        return;
      }
    }
  }, [isError])
  
  return { HdbPropertyData, hasMultipleAddress, singleProperty, noProperty, isIncluded, isLoading, isError }
}

export default useCheckHdbProperties